module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('h1', [_vm._v("Ihre Einkäufe")]), _vm._v(" "), _c('v-container', [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.invoices,
      "pagination": _vm.pagination,
      "rows-per-page-text": 'Aufträge pro Seite',
      "no-data-text": 'Keine Aufträge vorhanden'
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.moment(props.item.invoice_date).format('L')))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.invoice_nr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_type == 2 ? 'Kassenbon' : 'Rechnung'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.total.replace('.', ',')) + " €")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.invoiceDownload(props.item.invoice_id)
            }
          }
        }, [_vm._v("herunterladen")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Fehlt ein Einkauf?")]), _vm._v(" "), _c('v-container', [_vm._v("\n    Bitte Kassenbon-Nummer eintragen:"), _c('br'), _vm._v(" oder schreiben Sie uns eine Nachricht:"), _c('br')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-352009c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderOverview.vue
// module id = 583
// module chunks = 1